export default __webpack_public_path__ + "static/media/titulo_mexico.87048d39.png";